/** @namespace Steinkrueger/Util/DesktopDeliveryMenu/getNearestDateByWeekday */
export const getNearestDateByWeekday = (dayNumber: number | string) => {
    const date = new Date();
    const weekLength = 7;

    if (typeof dayNumber === 'number') {
        date.setDate(date.getDate() + (((dayNumber + weekLength - date.getDay()) % weekLength) || weekLength));
    }

    return date.toISOString();
};

/** @namespace Steinkrueger/Util/DesktopDeliveryMenu/formatDeliveryDate */
export const formatDeliveryDate = (date: string) => {
    const jsDate = new Date(date);
    const days = ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'];

    return days[ jsDate.getDay() ];
};
